/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { types } from '../actions/mark';

const defaultState = {
  mark: { from: null, to: null },
};

export default (state = defaultState, action) => {
  const { type, payload } = action;
  if (type === types.handleMark) {
    return {
      mark: payload,
    };
  }
  return state;
};




// WEBPACK FOOTER //
// ./src/redux/reducers/mark.js